import { render, staticRenderFns } from "./EditNewsContent.vue?vue&type=template&id=171f311a&scoped=true&"
import script from "./EditNewsContent.vue?vue&type=script&lang=ts&"
export * from "./EditNewsContent.vue?vue&type=script&lang=ts&"
import style0 from "./EditNewsContent.vue?vue&type=style&index=0&id=171f311a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171f311a",
  null
  
)

export default component.exports